import React, { Component } from 'react'

export default class HomePage extends Component {


    showHomeCategory = (category) => {

        window.location.href = '/category/' + category
    }

    render() {
        return (
            <React.Fragment style={{ display: 'flex' }}>

                <div className="row top-padding">
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-xl-3 col-md-4 mb-4 product-box">
                                <div className="wlc-usr-bx" onClick={() => this.showHomeCategory('man-watch')} >
                                    <div className="wlc-usr-bx-img">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/ecommerce-38d1f.appspot.com/o/man.jpg?alt=media&token=94729612-03e9-4998-8c17-19621f462021" alt="" className="img-fluid" />
                                    </div>
                                    <div className="wlc-usr-bx-text text-center">
                                        <h4>Man Watch</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-4 mb-4 product-box">
                                <div className="wlc-usr-bx" onClick={() => this.showHomeCategory('woman-watch')} >
                                    <div className="wlc-usr-bx-img">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/ecommerce-38d1f.appspot.com/o/woman.jpg?alt=media&token=8a36b468-702d-46f9-a4b4-dee1ba410772" alt="" className="img-fluid" />
                                    </div>
                                    <div className="wlc-usr-bx-text text-center">
                                        <h4>women Watch</h4>

                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-md-4 mb-4 product-box">
                                <div className="wlc-usr-bx" onClick={() => this.showHomeCategory('couple-watch')}>
                                    <div className="wlc-usr-bx-img">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/ecommerce-38d1f.appspot.com/o/couple.jpg?alt=media&token=fa7b7a84-837c-4b38-8cd0-c4edaa9a078b" alt="" className="img-fluid" />
                                    </div>
                                    <div className="wlc-usr-bx-text text-center">
                                        <h4>Couple Watch</h4>

                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-4 mb-4 product-box">
                                <div className="wlc-usr-bx" onClick={() => this.showHomeCategory('reviews')}>
                                    <div className="wlc-usr-bx-img">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/ecommerce-38d1f.appspot.com/o/review.jpg?alt=media&token=1843b38f-3b4d-4c1b-9b92-b15b3862be05" alt="" className="img-fluid" />
                                    </div>
                                    <div className="wlc-usr-bx-text text-center">
                                        <h4>Customer Reviews</h4>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row align-items-center justify-content-center">
                            <div className="col-xl-3 col-md-4 mb-4 product-box">
                                <div className="wlc-usr-bx" onClick={() => this.showHomeCategory('lower-range-watch')}>
                                    <div className="wlc-usr-bx-img">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/ecommerce-38d1f.appspot.com/o/man.jpg?alt=media&token=94729612-03e9-4998-8c17-19621f462021" alt="" className="img-fluid" />
                                    </div>
                                    <div className="wlc-usr-bx-text text-center">
                                        <h4>Lower range watch</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-4 mb-4 product-box">
                                <div className="wlc-usr-bx" onClick={() => this.showHomeCategory('accessories')} >
                                    <div className="wlc-usr-bx-img">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/ecommerce-38d1f.appspot.com/o/woman.jpg?alt=media&token=8a36b468-702d-46f9-a4b4-dee1ba410772" alt="" className="img-fluid" />
                                    </div>
                                    <div className="wlc-usr-bx-text text-center">
                                        <h4>Accessories</h4>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </React.Fragment>
        )
    }
}
